import { render, staticRenderFns } from "./TestPanelSetup.vue?vue&type=template&id=ff9d4b92&"
import script from "./TestPanelSetup.vue?vue&type=script&lang=js&"
export * from "./TestPanelSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports